import type { CSSProperties } from 'react';
import { useId } from 'react';

import { unitMapping } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  color?: Color;
  size?: keyof typeof unitMapping;
};

export const AllSeasons2026 = ({
  size = 2,
  color = 'var(--c-nd-900)',
}: Props) => {
  const id = useId();
  return (
    <svg
      style={{ height: unitMapping[size] }}
      viewBox="0 0 330 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={id}
        style={{ maskType: 'luminance' } as CSSProperties}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="330"
        height="232"
      >
        <path d="M330 0H0V232H330V0Z" fill={color} />
      </mask>
      <g mask={`url(#${id})`}>
        <path
          d="M347.358 177.689L280.323 232.448H-18V54.904L39.8281 0H347.358V177.689ZM164.903 29C132.722 29 120.154 39.1008 120.154 60.829V171.469C120.154 193.197 132.722 203.299 164.903 203.299C197.085 203.299 209.535 193.197 209.535 171.469V136.703H185.223V183.684H144.467V48.4971H185.223V95.243H209.535V60.829C209.535 39.1008 197.085 29 164.903 29Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
